import React, { useEffect, useState } from 'react';
import CustomCircularP from '../widgets/customCircularP';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { API_ENDPOINT } from '../../constants/constants';
import applogo from '../assets/svgs/applogo.svg'
import aprofile from '../assets/images/aprofile.png'
import AnswerBox from './answerBox';
import './ViewMockResult.css'
const ViewMockResult = () => {
    const [loading, setLoading] = useState(false)
    const [mockTest, setMockTest] = useState({})
    const { id } = useParams();

    useEffect(()=>{
        mtSheet()
    }, [id])
    function mtSheet(){
        setLoading(true)
        axios.get(API_ENDPOINT+'get-user-sheet/'+id).then(res=>{
            const d = res.data
            setLoading(false)
            if(d.success){
                setMockTest(d.message)
            }
        })        
    }

    return (
        <div>
            <CustomCircularP show={loading}/>
        {mockTest && Object.keys(mockTest).length>0 && <div className="user-response">
        <div>
            <div className="user-response-header">
                <img src={applogo}  style={{height: '90px', alignSelf: 'center'}}/>
                <div className="ur-atitle">{mockTest.title}</div>
                <div className="ur-details">
                    <center><svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
            <g clipPath="url(#clip0_772_1058)">
              <path d="M59.7488 10.2513C53.1381 3.64068 44.3488 0 35 0C25.6512 0 16.8619 3.64068 10.2512 10.2513C3.64068 16.8619 0 25.6512 0 35C0 44.3488 3.64068 53.1381 10.2512 59.7487C16.8619 66.3593 25.6512 70 35 70C44.3488 70 53.1381 66.3593 59.7488 59.7487C66.3593 53.1381 70 44.3488 70 35C70 25.6512 66.3593 16.8619 59.7488 10.2513ZM35 65.8984C25.8578 65.8984 17.6317 61.906 11.9695 55.5747C15.4797 46.2686 24.4655 39.6484 35 39.6484C28.2043 39.6484 22.6953 34.1395 22.6953 27.3438C22.6953 20.548 28.2043 15.0391 35 15.0391C41.7957 15.0391 47.3047 20.548 47.3047 27.3438C47.3047 34.1395 41.7957 39.6484 35 39.6484C45.5345 39.6484 54.5203 46.2686 58.0305 55.5747C52.3683 61.906 44.1422 65.8984 35 65.8984Z" fill="#444444"/>
            </g>
            <defs>
              <clipPath id="clip0_772_1058">
                <rect width="70" height="70" fill="white"/>
              </clipPath>
            </defs>
          </svg>
                    <div style={{fontSize: 15, color: '#444', marginTop: 8}}>{mockTest.candidate_name}</div>
                    <div style={{display: 'flex', color: 'green', justifyContent: 'center'}}>
                        <div style={{alignSelf: 'center'}}>Your Score</div>
                        <div style={{fontSize: 30, marginLeft: 16}}>{mockTest.allquestions.filter(mq=>mq.choiceCorrect).length+'/'+mockTest.numQns}</div>
                    </div>
                    </center>
                </div>
            </div>
            <div className="ur-content">
                <div className="ur-label-action">
                    <h2 style={{flex: 1}}>Answer Sheet</h2>        
                </div>
                {mockTest.allquestions.map(b=><AnswerBox assessment={mockTest}  answer={b} />)}
            </div>
        </div>
        </div>}
    </div>
    );
};

export default ViewMockResult;